// extracted by mini-css-extract-plugin
module.exports = {"page-title":"Home_page-title__3HsBd","error":"Home_error__1iJi7","loading":"Home_loading__zHlb3","spin":"Home_spin__3tI7O","home":"Home_home__1JXvv"};